import React from 'react';

import LoadingSection from './LoadingSection';

type Props = {
  error: Error | null | undefined;
  pastDelay: boolean;
};
// eslint-disable-next-line import/no-default-export
export default class LoadableLoadingSection extends React.PureComponent<Props> {
  render() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.error) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      throw this.props.error;
    }

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.pastDelay) {
      return <LoadingSection delay={0} />;
    }

    return null;
  }
}
